var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeerlessSteelActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 61.1,
    y1: 15.3,
    x2: 68,
    y2: 15.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 56.4,
    y1: 38.6,
    x2: 72.6,
    y2: 38.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 48.7,
    y1: 34.2,
    x2: 80.2,
    y2: 34.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 61.1,
    y1: 34.5,
    x2: 68,
    y2: 34.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 48.7,
    y1: 34.5,
    x2: 80.2,
    y2: 34.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 56.4,
    y1: 36.6,
    x2: 72.6,
    y2: 36.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 48.7,
    y1: 36.6,
    x2: 80.2,
    y2: 36.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 56.4,
    y1: 37.1,
    x2: 72.6,
    y2: 37.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 48.7,
    y1: 37.1,
    x2: 80.2,
    y2: 37.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 59.9,
    y1: 8.4,
    x2: 69.1,
    y2: 8.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 61.1,
    y1: 15.1,
    x2: 68,
    y2: 15.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x1: 59.9,
    y1: 15.1,
    x2: 69.1,
    y2: 15.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x1: -10.6,
    y1: 65.1,
    x2: -3.3,
    y2: 29.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#939697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96999a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x1: 17.5,
    y1: 57.7,
    x2: 21.2,
    y2: 39.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#939697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96999a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 18.7,
    y1: 63.3,
    x2: 22.2,
    y2: 46.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#939697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96999a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 19.8,
    y1: 69.2,
    x2: 23.1,
    y2: 53.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#939697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96999a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g17",
    x1: 20.7,
    y1: 75.8,
    x2: 24.1,
    y2: 59.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#939697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96999a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g18",
    x1: 136.4,
    y1: 34.4,
    x2: 145.5,
    y2: 70.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#939697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96999a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g19",
    x1: 109.6,
    y1: 41.7,
    x2: 114.4,
    y2: 60.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#939697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96999a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g20",
    x1: 108.8,
    y1: 48.4,
    x2: 113.2,
    y2: 66.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#939697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96999a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g21",
    x1: 108.1,
    y1: 55.1,
    x2: 112.3,
    y2: 71.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#939697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96999a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g22",
    x1: 107.5,
    y1: 61.4,
    x2: 111.8,
    y2: 78.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#939697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#979b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#44494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96999a"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#1f0a34}.b{fill:url(#g1)}.c{fill:url(#g2)}.d{fill:url(#g3)}.e{fill:url(#g4)}.f{fill:url(#g5)}.g{fill:url(#g6)}.h{fill:url(#g7)}.i{fill:url(#g8)}.j{fill:url(#g9)}.k{fill:url(#g10)}.l{fill:url(#g11)}.m{fill:url(#g12)}.n{fill:url(#g13)}.o{fill:url(#g14)}.p{fill:url(#g15)}.q{fill:url(#g16)}.r{fill:url(#g17)}.s{fill:url(#g18)}.t{fill:url(#g19)}.u{fill:url(#g20)}.v{fill:url(#g21)}.w{fill:url(#g22)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m127.4 64.2c0 35.1-28.4 63.6-63.5 63.6-35.1 0-63.6-28.5-63.6-63.6 0-35.1 28.5-63.5 63.6-63.5 35.1 0 63.5 28.4 63.5 63.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m64.4 34.9q-1.9-0.3-3.3-0.4 0.1-0.4 0.3-0.8 0.4-0.8 0.4-1.7c0-0.5-0.1-1-0.3-1.4-0.2-0.6-0.2-1.2 0-1.8 0.1-0.4 0.3-0.9 0.3-1.4 0-0.5-0.1-1-0.3-1.4-0.2-0.6-0.2-1.2 0-1.8 0.1-0.4 0.3-0.9 0.3-1.4 0-0.5-0.1-1-0.3-1.5-0.2-0.5-0.2-1.1 0-1.7 0.1-0.4 0.3-0.9 0.3-1.4q0-1-0.4-1.7-0.3-0.6-0.3-1.2l2.2 1.6c0.7 0.5 1.7 0.5 2.4 0l2.3-1.6q-0.1 0.6-0.3 1.2-0.5 0.7-0.5 1.7c0 0.5 0.2 1 0.3 1.4 0.2 0.6 0.2 1.2 0 1.7-0.2 0.5-0.3 1-0.3 1.5 0 0.5 0.2 1 0.3 1.4 0.2 0.6 0.2 1.2 0 1.8q-0.3 0.6-0.3 1.4c0 0.5 0.2 1 0.3 1.4 0.2 0.6 0.2 1.2 0 1.8-0.2 0.4-0.3 0.9-0.3 1.4q0 0.9 0.5 1.7 0.1 0.4 0.2 0.8-1.5 0.1-3.5 0.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m68.5 38.6c0.1 5.2 0.9 11.9 4 15.8l0.1 0.1c-3-0.2-6.7 18.1-1.3 25l0.1 0.1-0.1 0.1c-2.3 3-2.8 6.4-3.2 10-0.8 7.5 0.4 18.6-3.6 30.4-4.1-11.8-2.9-23-3.7-30.5-0.4-3.6-0.9-7-3.2-10 5.3-6.8 1.7-25.3-1.2-25.1 3.1-4 3.9-10.7 3.9-15.9 1.7 0.7 3.1 2 4.1 3.6v0.1l0.1-0.1c1-1.6 2.4-2.9 4-3.6zm-4.9 5.9c0 0.4 0.3 0.8 0.8 0.8 0.4 0 0.7-0.4 0.7-0.8 0-0.4-0.3-0.7-0.7-0.7-0.5 0-0.8 0.3-0.8 0.7zm-0.3 3.5c0 0.7 0.5 1.2 1.1 1.2 0.7 0 1.2-0.5 1.2-1.2 0-0.6-0.5-1.1-1.2-1.1-0.6 0-1.1 0.5-1.1 1.1zm-1.6 5.8q0 0.1-0.1 0.2 0.1 0.2 0.2 0.4 0.4 0.8 0.8 1.7c0.6 1.8 0.9 3.7 0.9 5.6v13.2c0 1.5-0.3 2.9-0.8 4.2q-0.1 0.2-0.2 0.4 0 0.1 0.1 0.1c0.6 1.3 0.9 2.6 0.9 4.1l0.3 19.3c0 4.8 0.2 5.6 0.7 7.3 0.4-1.7 0.6-2.4 0.6-7.3 0-4.9 0.3-18 0.3-19.4 0-1.4 0.3-2.8 1-4.1q0 0 0 0 0 0 0 0c-0.7-1.4-1-2.9-1-4.5v-13.3c0-2.3 0.5-4.6 1.4-6.7q0.1-0.3 0.2-0.5 0.2-0.3 0.3-0.5-0.1-0.1-0.1-0.2c-1.1-2.4-4.4-2.4-5.5 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "d",
    d: "m76 46.6c1.5-5.9 1-8.4-2.8-8.8-1.6-0.2-3.2 0.1-4.7 0.8q0-0.4 0-0.8c0-1.2-1-0.1-1-0.6v-0.1q1.6-0.8 3.4-1.1-2.1 0.1-5.5 0.6h-1.9q-3.4-0.5-5.5-0.6 1.8 0.3 3.4 1.1v0.1c0 0.5-1.1-0.5-1.1 0.6q0 0.4 0 0.8c-1.4-0.7-3-1-4.7-0.8-3.7 0.4-4.2 2.9-2.7 8.8-2.2-2.5-5.4-5.6-3.8-12.2 6.3 1.2 3.2-0.9 12 0.1q0 0.2 0 0.4v0.8h6.9v-0.8q-0.1-0.2-0.1-0.4c8.6-1 5.6 1.1 11.9-0.1 1.6 6.6-1.6 9.7-3.8 12.2zm-22.8-10.1q-0.5 0.1-1.1 0.1-0.7 0-1.7-0.1c-0.1 1.1-0.5 2.9 0.4 5-0.1-1-0.8-3.6 2.4-5zm24.9 5c0.9-2.1 0.5-3.9 0.3-5q-0.9 0.1-1.6 0.1-0.6 0-1.1-0.1c3.2 1.4 2.5 4 2.4 5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m61.1 34.9q0-0.2 0-0.4 1.4 0.1 3.3 0.4 2-0.3 3.5-0.4 0 0.2 0.1 0.4v0.8h-3.4-0.2-3.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m61.1 34.9q0-0.2 0-0.4 1.4 0.1 3.3 0.4 2-0.3 3.5-0.4 0 0.2 0.1 0.4v0.8h-3.4-0.2-3.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m64.2 36.7q-0.4-0.1-0.7-0.1h1.9q-0.3 0-0.7 0.1h-0.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m64.2 36.7q-0.4-0.1-0.7-0.1h1.9q-0.3 0-0.7 0.1h-0.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m68.5 37.8q0 0.4 0 0.8c-1.6 0.7-3 2-4 3.6l-0.1 0.1v-0.1c-1-1.6-2.4-2.9-4.1-3.6q0-0.4 0-0.8c0-1.1 1.1-0.1 1.1-0.6v-0.1q1.7 0.8 3 2.2 1.4-1.4 3.1-2.2v0.1c0 0.5 1-0.6 1 0.6z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m68.5 37.8q0 0.4 0 0.8c-1.6 0.7-3 2-4 3.6l-0.1 0.1v-0.1c-1-1.6-2.4-2.9-4.1-3.6q0-0.4 0-0.8c0-1.1 1.1-0.1 1.1-0.6v-0.1q1.7 0.8 3 2.2 1.4-1.4 3.1-2.2v0.1c0 0.5 1-0.6 1 0.6z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "k",
    d: "m61.1 15.3q0 0 0 0l-0.3-0.2c-0.8-0.6-1.1-1.5-0.8-2.3l1-3c0.3-0.9 1-1.4 1.9-1.4h3.2c0.9 0 1.6 0.5 1.9 1.4l1 3c0.3 0.8 0 1.7-0.7 2.3l-0.3 0.2q0 0 0 0v-0.2h-6.9zm1.5-1.5l1.4 1c0.3 0.2 0.7 0.2 1 0l1.4-1c0.3-0.2 0.4-0.6 0.3-1l-0.5-1.6c-0.1-0.4-0.5-0.6-0.9-0.6h-1.6c-0.4 0-0.8 0.2-0.9 0.6l-0.5 1.6c-0.1 0.4 0 0.8 0.3 1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m63.3 16.9l-2.2-1.6q0 0 0 0v-0.2h3.3 0.2 3.4v0.2q0 0 0 0l-2.3 1.6c-0.7 0.5-1.7 0.5-2.4 0z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m63.3 16.9l-2.2-1.6q0 0 0 0v-0.2h3.3 0.2 3.4v0.2q0 0 0 0l-2.3 1.6c-0.7 0.5-1.7 0.5-2.4 0z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m16.5 34.4c0 0 24.1 21.6 35 27.1 0 0-6.7 12.7-1.6 24.7 0 0-5.9-8.7-1.8-23.9 0 0-26.6-20.9-31.6-27.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m45.7 63.4l-0.5 2.4c0 0-19.5-15.5-27-24.7 0 0 17.2 15.8 27.5 22.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m45 68.5l-0.3 2.4c0 0-17.8-14.4-24.9-23 0 0 15.5 14.5 25.2 20.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m44.6 73.9l0.1 2.6c0 0-16.9-13.8-23.3-21.8 0 0 14.4 13.6 23.2 19.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m45.6 80.1l0.8 3.3c0 0-17.7-14.6-24.1-22.6 0 0 14.4 13.7 23.3 19.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m80.9 62.3c4.7 15-0.7 23.9-0.7 23.9 4.5-12.2-2.8-24.5-2.8-24.5 10.7-6.1 33.9-28.7 33.9-28.7-4.7 7.3-30.4 29.3-30.4 29.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m109.8 39.8c-7.1 9.5-25.9 25.8-25.9 25.8l-0.6-2.4c10-6.9 26.5-23.4 26.5-23.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m108.5 46.6c-6.7 8.9-23.9 24.1-23.9 24.1l-0.4-2.4c9.5-6.5 24.3-21.7 24.3-21.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m107.2 53.5c-6 8.2-22.3 22.8-22.3 22.8v-2.6c8.5-6 22.3-20.2 22.3-20.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m106.6 59.7c-6.1 8.2-23.2 23.6-23.2 23.6l0.8-3.4c8.6-6 22.4-20.2 22.4-20.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeerlessSteelActive);
export default __webpack_public_path__ + "static/media/peerless-steel-active.d4a2d351d9bf8aad5c779aa4141b3506.svg";
export { ForwardRef as ReactComponent };